"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SortableStateEventConditionItem = exports.StateEventConditionItem = exports.StateEventConditions = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const core_1 = require("@dnd-kit/core");
const sortable_1 = require("@dnd-kit/sortable");
const utilities_1 = require("@dnd-kit/utilities");
const core_2 = require("@material-ui/core");
const icons_1 = require("@material-ui/icons");
const core_ui_1 = require("@sierralabs/core-ui");
const StateEventConditionDialog_1 = __importDefault(require("../dialogs/StateEventConditionDialog"));
const Workflow_context_1 = require("../Workflow.context");
const StyledDiv = styled_components_1.default.div `
  margin-top: 10px;
`;
const StyledList = (0, styled_components_1.default)(core_2.List) `
  .condition-item:not(:last-child) {
    margin-bottom: 10px;
  }
`;
const StyledListItem = (0, styled_components_1.default)(core_2.ListItem) `
  &.dragging {
    opacity: 0.75;
  }
`;
const StateEventConditions = props => {
    var _a;
    const { event, taskTypeId, transition: initialTransition, onChange } = props;
    const { transitionConditionPlugins } = (0, Workflow_context_1.useWorkflowContext)();
    const dragChangeRef = (0, react_1.useRef)({ sourceIndex: -1, targetIndex: -1 });
    const [openDialog, setOpenDialog] = (0, react_1.useState)(false);
    const [transition, setTransition] = (0, react_1.useState)(initialTransition);
    const [selectedConditionIndex, setSelectedConditionIndex] = (0, react_1.useState)(-1);
    const [dragItem, setDragItem] = (0, react_1.useState)();
    const conditionsWithId = (0, core_ui_1.useWithId)(transition.conditions || []);
    const sort = (0, core_ui_1.useSort)(conditionsWithId, item => item.id);
    const sensors = (0, core_1.useSensors)((0, core_1.useSensor)(core_1.PointerSensor));
    const getLabel = (condition) => {
        const plugin = transitionConditionPlugins.find(p => p.type === condition.type);
        return (plugin === null || plugin === void 0 ? void 0 : plugin.label) || condition.type;
    };
    const clearDragChange = () => {
        dragChangeRef.current.sourceIndex = -1;
        dragChangeRef.current.targetIndex = -1;
    };
    return (react_1.default.createElement(StyledDiv, null,
        react_1.default.createElement(core_1.DndContext, { sensors: sensors, onDragStart: event => {
                // prevent dragging if currently dragging an item
                if (dragItem) {
                    return;
                }
                const index = conditionsWithId.findIndex(item => item.id === event.active.id);
                const item = conditionsWithId[index];
                dragChangeRef.current.sourceIndex = index;
                setDragItem(item);
            }, onDragOver: event => {
                const { active, over } = event;
                if (over && active.id !== over.id) {
                    dragChangeRef.current.targetIndex = sort.findIndex(over.id);
                    sort.reorder(active.id, over.id);
                }
            }, onDragEnd: () => {
                const { sourceIndex, targetIndex } = dragChangeRef.current;
                if (sourceIndex > -1 &&
                    targetIndex > -1 &&
                    sourceIndex !== targetIndex &&
                    transition.conditions) {
                    const deleted = transition.conditions.splice(sourceIndex, 1);
                    transition.conditions.splice(targetIndex, 0, ...deleted);
                    setTransition(Object.assign({}, transition));
                    onChange === null || onChange === void 0 ? void 0 : onChange(transition);
                }
                clearDragChange();
                setDragItem(undefined);
            }, onDragCancel: () => {
                clearDragChange();
                setDragItem(undefined);
            } },
            react_1.default.createElement(sortable_1.SortableContext, { items: sort.items.map(item => item.id) },
                react_1.default.createElement(StyledList, { dense: true }, sort.items.map((item, index) => (react_1.default.createElement(exports.SortableStateEventConditionItem, { key: item.id, conditionId: item.id, label: getLabel(item.item), onClick: () => {
                        setSelectedConditionIndex(index);
                        setOpenDialog(true);
                    } }))))),
            react_1.default.createElement(core_1.DragOverlay, null, dragItem && (react_1.default.createElement(exports.StateEventConditionItem, { isDragging: true, conditionId: dragItem.id, label: getLabel(dragItem.item) })))),
        react_1.default.createElement(core_2.Button, { fullWidth: true, variant: 'outlined', startIcon: react_1.default.createElement(icons_1.Add, null), onClick: () => setOpenDialog(true) }, "Add Condition"),
        openDialog && (react_1.default.createElement(StateEventConditionDialog_1.default, { event: event, open: openDialog, taskTypeId: taskTypeId, condition: (_a = transition.conditions) === null || _a === void 0 ? void 0 : _a[selectedConditionIndex], onCancel: () => {
                setOpenDialog(false);
                setSelectedConditionIndex(-1);
            }, onChange: condition => {
                if (!transition.conditions) {
                    transition.conditions = [];
                }
                if (selectedConditionIndex >= 0) {
                    transition.conditions[selectedConditionIndex] = condition;
                    setSelectedConditionIndex(-1);
                    setTransition(Object.assign({}, transition));
                }
                else {
                    transition.conditions.push(condition);
                    setTransition(Object.assign({}, transition));
                }
                onChange === null || onChange === void 0 ? void 0 : onChange(transition);
                setOpenDialog(false);
            }, onDelete: () => {
                setOpenDialog(false);
                if (transition.conditions && selectedConditionIndex >= 0) {
                    transition.conditions.splice(selectedConditionIndex, 1);
                    setSelectedConditionIndex(-1);
                    setTransition(Object.assign({}, transition));
                    onChange === null || onChange === void 0 ? void 0 : onChange(transition);
                }
            } }))));
};
exports.StateEventConditions = StateEventConditions;
exports.default = exports.StateEventConditions;
const StateEventConditionItem = props => {
    const { label, isDragging = false, listItemProps, dragHandleProps, onClick } = props;
    const classes = ['condition-item'];
    (listItemProps === null || listItemProps === void 0 ? void 0 : listItemProps.className) && classes.push(listItemProps.className);
    isDragging && classes.push('dragging');
    return (react_1.default.createElement(StyledListItem, Object.assign({}, listItemProps, { button: true, className: classes.join(' '), onClick: () => onClick === null || onClick === void 0 ? void 0 : onClick() }),
        react_1.default.createElement(core_2.ListItemIcon, Object.assign({}, dragHandleProps),
            react_1.default.createElement(icons_1.DragIndicator, null)),
        react_1.default.createElement(core_2.ListItemText, { primary: label })));
};
exports.StateEventConditionItem = StateEventConditionItem;
const SortableStateEventConditionItem = props => {
    const { conditionId } = props;
    const { attributes, isDragging, listeners, setNodeRef, transform, transition } = (0, sortable_1.useSortable)({ id: conditionId });
    return (react_1.default.createElement(exports.StateEventConditionItem, Object.assign({}, props, { isDragging: isDragging, dragHandleProps: Object.assign(Object.assign({}, attributes), listeners), listItemProps: {
            innerRef: setNodeRef,
            style: {
                opacity: isDragging ? 0.75 : undefined,
                transform: utilities_1.CSS.Translate.toString(transform),
                transition: transition || undefined
            }
        } })));
};
exports.SortableStateEventConditionItem = SortableStateEventConditionItem;
//# sourceMappingURL=StateEventConditions.js.map